import React from 'react';
import "./Style.css"
import ReactPlayer from 'react-player';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const PagePreview = ({ pageData, blocksData }) => {

    return (
        <div className={`max-w-xl ms-auto h-[650px] rounded-xl border-2 overflow-hidden overflow-y-auto flex flex-col`}
            style={{
                fontFamily: pageData?.textOption?.font,
                backgroundColor: pageData?.backgroundOption?.color ? pageData?.backgroundOption?.color : pageData?.backgroundOption?.image ? 'unset' : '#ECECF2',
                backgroundRepeat: 'no-repeat',
                backgroundImage: pageData?.backgroundOption?.gradient?.length ? `linear-gradient(${pageData?.backgroundOption?.gradientAngle} ,${pageData?.backgroundOption?.gradient[0]}, ${pageData?.backgroundOption?.gradient[1]})` : pageData?.backgroundOption?.image ? `url(${(pageData?.backgroundOption?.image)})` : 'unset',
                backgroundSize: pageData?.backgroundOption?.image ? 'cover' : 'unset',
                backgroundPosition: pageData?.backgroundOption?.image ? 'center' : 'unset',
            }}>

            {pageData?.layout == 1 && <Head1 pageData={pageData} />}
            {pageData?.layout == 2 && <Head2 pageData={pageData} />}
            {pageData?.layout == 3 && <Head3 pageData={pageData} />}
            {pageData?.layout == 4 && <Head4 pageData={pageData} />}
            {pageData?.layout == 5 && <Head5 pageData={pageData} />}

            <div className="flex flex-col gap-3 p-3 flex-1">
                {pageData?.socialLinks?.length > 0 && <div className={`flex justify-center gap-3 flex-wrap ${pageData?.socialLinksOption?.placement == "top" ? 'order-1' : 'order-2'}`}>
                    {
                        pageData?.socialLinks?.map((item) => {
                            return (
                                <a key={item.sortId} href={item.channelLink} target='_blank' rel='noopener noreferrer'>
                                    <img src={item?.icon} alt="" className='h-7 object-contain' />
                                </a>
                            )
                        })
                    }
                </div>}
                <div className={`flex flex-1 flex-col !gap-4 ${pageData?.socialLinksOption?.placement == "top" ? 'order-2' : 'order-1'}`}>
                    {
                        blocksData?.map((block, index) => {
                            return (
                                <div key={index}>
                                    {block?.blockType == 1 && <LinkComponent blockData={block} designData={pageData} />}
                                    {block?.blockType == 2 && <ImageComponent blockData={block} designData={pageData} />}
                                    {block?.blockType == 3 && <YoutubeComponent blockData={block} designData={pageData} />}
                                    {block?.blockType == 4 && <SliderComponent blockData={block} designData={pageData} />}
                                    {block?.blockType == 5 && <GridComponent blockData={block} designData={pageData} />}
                                </div>
                            )
                        })
                    }
                </div>
                <div className="flex order-3 items-center justify-center">
                    <div className="aspect-square bg-white flex items-center justify-center rounded-full p-0.5 shadow-md">
                        <img src={process.env.PUBLIC_URL + "/images/icon-logo.png"} className='h-4' alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PagePreview;

export const Head1 = ({ pageData }) => {
    return (
        <div className='px-2 py-4 text-center'>
            {pageData?.image ? <img src={pageData?.image && (pageData?.image)} alt="" className='h-24 aspect-square ms-auto me-auto rounded-full object-cover' /> : <div className='h-24 aspect-square ms-auto bg-[#B1B3C8] me-auto rounded-full object-cover'></div>}
            {<p className='mt-2 mb-1 text-lg font-bold capitalize' style={{ color: pageData?.textOption?.titleColor ? pageData?.textOption?.titleColor : '#070707' }}>{pageData?.title ?? "Welcome"}</p>}
            {pageData?.description && <p className='mb-1 text-sm font-medium' style={{ color: pageData?.textOption?.descriptionColor ? pageData?.textOption?.descriptionColor : '#526281' }}>{pageData?.description}</p>}
        </div>
    )
}

export const Head2 = ({ pageData }) => {
    return (
        <div className='h-max'>
            <div style={{
                clipPath: 'polygon(0% 0%, 0% 100%, 0.818% 99.342%, 0.818% 99.342%, 10.507% 92.4%, 20.353% 87.015%, 30.317% 83.189%, 40.358% 80.92%, 50.437% 80.209%, 60.514% 81.054%, 70.549% 83.456%, 80.501% 87.415%, 90.331% 92.929%, 100% 100%, 100% 0%, 0% 0%)', width: '100%', height: '12.8rem',
                backgroundColor: pageData?.headerOption?.color ? pageData?.headerOption?.color : '#d4d4d4',
                backgroundImage: pageData?.headerOption?.gradient?.length ? `linear-gradient(${pageData?.headerOption?.gradientAngle} ,${pageData?.headerOption?.gradient[0]}, ${pageData?.headerOption?.gradient[1]})` : pageData?.headerOption?.image ? `url(${(pageData?.headerOption?.image)})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }} >
            </div>
            <div className="relative mt-[-90px] text-center">
                {pageData?.image ? <img src={pageData?.image && (pageData?.image)} alt="" className='h-24 aspect-square ms-auto me-auto rounded-full object-cover' /> : <div className='h-24 aspect-square ms-auto bg-[#B1B3C8] me-auto rounded-full object-cover'></div>}
                {pageData?.title && <p className='mt-2 mb-1 text-lg font-bold capitalize' style={{ color: pageData?.textOption?.titleColor ? pageData?.textOption?.titleColor : '#070707' }}>{pageData?.title}</p>}
                {pageData?.description && <p className='mb-1 text-sm font-medium' style={{ color: pageData?.textOption?.descriptionColor ? pageData?.textOption?.descriptionColor : '#526281' }}>{pageData?.description}</p>}
            </div>
        </div>

    )
}

export const Head3 = ({ pageData }) => {
    return (
        <div className=''>
            <div className='h-44 w-full' style={{
                backgroundColor: pageData?.headerOption?.color ? pageData?.headerOption?.color : pageData?.headerOption?.image ? 'unset' : '#d4d4d4',
                backgroundImage: pageData?.headerOption?.gradient?.length ? `linear-gradient(${pageData?.headerOption?.gradientAngle} ,${pageData?.headerOption?.gradient[0]}, ${pageData?.headerOption?.gradient[1]})` : pageData?.headerOption?.image ? `url(${(pageData?.headerOption?.image)})` : 'unset',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}>
            </div>
            <div className="relative mt-[-55px] text-left px-4">
                {pageData?.image ? <img src={pageData?.image && (pageData?.image)} alt="" className='h-24 aspect-square me-auto rounded-full object-cover' /> : <div className='h-24 aspect-square bg-[#B1B3C8] rounded-full object-cover'></div>}
                {pageData?.title && <p className='mt-2 mb-1 text-lg font-bold capitalize' style={{ color: pageData?.textOption?.titleColor ? pageData?.textOption?.titleColor : '#070707' }}>{pageData?.title}</p>}
                {pageData?.description && <p className='mb-1 text-sm font-medium' style={{ color: pageData?.textOption?.descriptionColor ? pageData?.textOption?.descriptionColor : '#526281' }}>{pageData?.description}</p>}
            </div>
        </div>

    )
}

export const Head4 = ({ pageData }) => {
    return (
        <div className=''>
            <div className='h-44 w-full text-center pt-5' style={{
                backgroundColor: pageData?.headerOption?.color ? pageData?.headerOption?.color : pageData?.headerOption?.image ? 'unset' : '#d4d4d4',
                backgroundImage: pageData?.headerOption?.gradient?.length ? `linear-gradient(${pageData?.headerOption?.gradientAngle} ,${pageData?.headerOption?.gradient[0]}, ${pageData?.headerOption?.gradient[1]})` : pageData?.headerOption?.image ? `url(${(pageData?.headerOption?.image)})` : 'unset',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }} >
            </div>
            <div className="relative mt-[-55px] text-center">
                {pageData?.image ? <img src={pageData?.image && (pageData?.image)} alt="" className='h-24 aspect-square ms-auto me-auto rounded-full object-cover' /> : <div className='h-24 aspect-square ms-auto bg-[#B1B3C8] me-auto rounded-full object-cover'></div>}
                {pageData?.title && <p className='text-lg font-bold capitalize whitespace-nowrap mt-2 mb-2' style={{ color: pageData?.textOption?.titleColor ? pageData?.textOption?.titleColor : '#070707' }}>{pageData?.title}</p>}
                {pageData?.description && <p className='mb-1 mt-1 text-sm font-medium' style={{ color: pageData?.textOption?.descriptionColor ? pageData?.textOption?.descriptionColor : '#526281' }}>{pageData?.description}</p>}
            </div>
        </div>

    )
}

export const Head5 = ({ pageData }) => {
    return (
        <div className='px-2 py-4'>
            <div className="flex items-center">
                {pageData?.title && <p className='text-lg font-bold capitalize mb-0' style={{ color: pageData?.textOption?.titleColor ? pageData?.textOption?.titleColor : '#070707' }}>{pageData?.title}</p>}
                {pageData?.image ? <img src={pageData?.image && (pageData?.image)} alt="" className='h-8 aspect-square ms-auto rounded-full object-cover' /> : <div className='h-8 aspect-square ms-auto bg-[#B1B3C8] rounded-full object-cover'></div>}
            </div>
            {pageData?.description && <div className='mt-3 border-t-2 border-b-2 border-[#686C8F] py-2'> <p className='mb-0 text-sm font-medium' style={{ color: pageData?.textOption?.descriptionColor ? pageData?.textOption?.descriptionColor : '#526281' }}>{pageData?.description}</p></div>}
        </div>

    )
}

export const LinkComponent = ({ blockData, designData }) => {
    return (
        blockData?.images?.map((item, i) => {
            return (
                <div className='px-4 py-2 flex items-center justify-center gap-3' key={i} style={{
                    backgroundColor: designData?.blocksOption?.background,
                    borderRadius: designData?.blocksOption?.borderRadius,
                    boxShadow: designData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${designData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`,
                    borderWidth: designData?.blocksOption?.border,
                    borderStyle: 'solid',
                    borderColor: designData?.blocksOption?.borderColor
                }}>
                    {item?.image && <img src={item?.image && (item?.image)} alt="" className='h-12 w-12 aspect-square rounded-lg object-cover' />}
                    <div className='w-full text-center'>
                        {item?.title && <p className='mb-0 text-md font-semibold capitalize' style={{ color: designData?.blocksOption?.titleColor ? designData?.blocksOption?.titleColor : '#070707' }}>{item?.title}</p>}
                        {item?.description && <p className='mb-0 text-sm font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{item?.description}</p>}
                    </div>
                </div>
            )
        })
    )
}

export const ImageComponent = ({ blockData, designData }) => {
    return (
        blockData?.images?.map((item, i) => {
            return (
                <div className='' key={i}>
                    <img src={item?.image} alt="" className='h-auto w-full mb-2 object-cover' style={{
                        aspectRatio: item?.aspectRatio,
                        borderRadius: designData?.blocksOption?.borderRadius,
                        boxShadow: designData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${designData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`
                    }} />
                    <div className='w-full text-center'>
                        {item?.title && <p className='mb-0 text-md font-semibold capitalize' style={{ color: designData?.blocksOption?.titleColor ? designData?.blocksOption?.titleColor : '#070707' }}>{item?.title}</p>}
                        {item?.description && <p className='mb-0 text-sm font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{item?.description}</p>}
                    </div>
                </div>)
        })
    )
}

export const YoutubeComponent = ({ blockData, designData }) => {
    return (
        blockData?.images?.map((item, i) => {
            return (
                <div className='' key={i}>
                    <ReactPlayer url={item?.destinationUrl} width={'100%'} height={'auto'} style={{
                        borderRadius: designData?.blocksOption?.borderRadius,
                        boxShadow: designData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${designData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`,
                        overflow: 'hidden'
                    }} />
                </div>)
        })
    )
}

export const SliderComponent = ({ blockData, designData }) => {
    return (
        <Swiper
            spaceBetween={30}
            slidesPerView={'auto'}
            className=''
            onSlideChange={() => { }}
            onSwiper={(swiper) => { }}
        >
            {
                blockData?.images?.filter(item => item?.status == 1)?.map((item, i) => {
                    return (
                        <SwiperSlide key={item?._id} style={{ width: blockData?.images?.length == 1 ? '100%' : 'max-content' }}>
                            <img src={item?.image} alt="" className={`h-[270px] ${blockData?.images?.length == 1 ? 'w-full' : 'w-[270px]'} object-cover`} style={{
                                borderRadius: designData?.blocksOption?.borderRadius,
                                boxShadow: designData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${designData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`
                            }} />
                        </SwiperSlide>
                    )
                })
            }
        </Swiper>
    )
}

export const GridComponent = ({ blockData, designData }) => {
    return (
        <div className={`grid gap-3 ${((blockData?.images?.length % 3 == 0) || (blockData?.images?.length > 6)) ? 'grid-cols-3' : ((blockData?.images?.length % 2 == 0) || (blockData?.images?.length > 4)) ? 'grid-cols-2' : 'grid-cols-1'}`}>
            {blockData?.images?.filter(item => item?.status == 1)?.map((item, i) => {
                return (
                    <div className='col-span-1' key={i}>
                        <img src={item?.image} alt="" className='h-full w-full object-cover'
                            style={{
                                borderRadius: designData?.blocksOption?.borderRadius,
                                boxShadow: designData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${designData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`
                            }}
                        />
                    </div>)
            })}
        </div>
    )
}